
import { Server, Wrench, Monitor, Settings } from "lucide-react";

const ServiceCard = ({ 
  title, 
  titleCn, 
  description, 
  descriptionCn, 
  icon: Icon 
}: { 
  title: string;
  titleCn: string;
  description: string;
  descriptionCn: string;
  icon: React.ElementType;
}) => {
  return (
    <div className="service-card">
      <div className="flex items-center mb-4">
        <div className="p-2 bg-wiiseng-blue/10 rounded-lg">
          <Icon className="h-7 w-7 text-wiiseng-blue" />
        </div>
      </div>
      <h3 className="text-xl font-semibold mb-1">{title}</h3>
      <h4 className="text-lg text-wiiseng-gray mb-2">{titleCn}</h4>
      <p className="text-sm text-wiiseng-gray mb-3">{description}</p>
      <p className="text-sm text-wiiseng-gray">{descriptionCn}</p>
    </div>
  );
};

const ServicesSection = () => {
  const services = [
    {
      title: "CNC Machine Servicing",
      titleCn: "CNC 机床维修",
      description: "Repair and servicing for multi-axis CNC mills, lathes, grinders, and EDM machines.",
      descriptionCn: "为多轴 CNC 铣床、车床、磨床和电火花机提供维修与保养服务",
      icon: Server
    },
    {
      title: "Maintenance & Repair",
      titleCn: "维护和维修",
      description: "Comprehensive maintenance, repair, and troubleshooting for optimal performance.",
      descriptionCn: "全面的维护、维修和故障排除，确保最佳性能",
      icon: Wrench
    },
    {
      title: "System Diagnostics",
      titleCn: "系统诊断",
      description: "Advanced diagnostics and preventive maintenance to minimize downtime.",
      descriptionCn: "先进的诊断和预防性维护，减少停机时间",
      icon: Monitor
    },
    {
      title: "Retrofitting & Calibration",
      titleCn: "改造和校准",
      description: "Machine retrofitting, calibration, and spindle repair services.",
      descriptionCn: "机床改造、校准和主轴维修服务",
      icon: Settings
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Services</h2>
          <p className="text-lg text-wiiseng-gray max-w-2xl mx-auto">
            Practical CNC repair and maintenance to keep your shop running
          </p>
          <p className="text-lg text-wiiseng-gray max-w-2xl mx-auto">
            实用的 CNC 维修与保养服务，让您的车间稳定运转
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
